import React from 'react';
import PropTypes from 'prop-types';

import SVGIcon from './SVGIcon';

const iconName = percentageChange => {
  if (percentageChange === 0 ) {
    return 'mover-same'
  } else if (percentageChange > 0 ) {
    return 'mover-up';
  }
  return 'mover-down';
}

const iconClass = percentageChange => {
  if (percentageChange === 0 ) {
    return 'BiggestMovers_mover-same'
  } else if (percentageChange > 0 ) {
    return 'BiggestMovers_mover-up';
  }
  return 'BiggestMovers_mover-down';
}

const BiggestMoversItem = props => (
  <li>
    <span className="BiggestMovers_title">{props.name}</span>
    <SVGIcon
      icon={iconName(props.percentageChange)}
      className={iconClass(props.percentageChange)}
    />
    <span className="BiggestMovers_percentage">{Math.round(Math.abs(props.percentageChange))}%</span>
  </li>
);

BiggestMoversItem.propTypes = {
  name: PropTypes.string.isRequired,
  percentageChange: PropTypes.number.isRequired,
};

const BiggestMovers = props => (
  <div className="BiggestMovers">
    <h4>Subcategories</h4>
    <div className="BiggestMovers_charts">
      <ul>{props.data.subcategories.top.map(item => <BiggestMoversItem {...item} key={item.name} />)}</ul>
      <ul>{props.data.subcategories.bottom.map(item => <BiggestMoversItem {...item} key={item.name} />)}</ul>
    </div>
    <h4>Organisations</h4>
    <div className="BiggestMovers_charts">
      <ul>{props.data.organisations.top.map(item => <BiggestMoversItem {...item} key={item.name} />)}</ul>
      <ul>{props.data.organisations.bottom.map(item => <BiggestMoversItem {...item} key={item.name} />)}</ul>
    </div>
  </div>
);

BiggestMovers.propTypes = {
  data: PropTypes.shape({
    subcategories: PropTypes.object,
    organisations: PropTypes.object,
  }).isRequired,
};

export default BiggestMovers;
